import { render, staticRenderFns } from "./PageHRPolicies.vue?vue&type=template&id=2386a436&"
import script from "./PageHRPolicies.vue?vue&type=script&lang=js&"
export * from "./PageHRPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports